export const BOARD = {
  width: 3900,
  height: 3330,
};

/** Where the camera opens: the middle of the subject dossier card. */
export const MAP_FOCUS = {
  x: 1950,
  y: 1150,
};

/**
 * Sections are pinned by their top-left corner; their size comes from their content
 * and is measured at runtime (see BoardGeometry), so nothing here needs a height.
 */
export const SECTIONS = {
  overview: {
    id: "overview",
    left: 1455,
    top: 800,
    number: "00",
    kicker: "Subject file",
    title: "The subject",
    nav: "Subject",
  },
  projects: {
    id: "projects",
    left: 1330,
    top: 1640,
    number: "01",
    kicker: "Physical evidence",
    title: "Exhibits",
    nav: "Exhibits",
  },
  experience: {
    id: "experience",
    left: 800,
    top: 130,
    number: "02",
    kicker: "Known whereabouts",
    title: "Employment record",
    nav: "Employment",
  },
  skills: {
    id: "skills",
    left: 250,
    top: 800,
    number: "03",
    kicker: "Modus operandi",
    title: "Tools & methods",
    nav: "Skills",
  },
  education: {
    id: "education",
    left: 250,
    top: 2180,
    number: "04",
    kicker: "Background check",
    title: "Academic record",
    nav: "Education",
  },
  portraits: {
    id: "portraits",
    left: 2820,
    top: 800,
    number: "05",
    kicker: "Surveillance log",
    title: "Sightings",
    nav: "Sightings",
  },
  leadership: {
    id: "leadership",
    left: 2820,
    top: 1700,
    number: "06",
    kicker: "Side file · off the clock",
    title: "Operations record",
    nav: "Side file",
  },
  contact: {
    id: "contact",
    left: 2820,
    top: 2560,
    number: "07",
    kicker: "Final report",
    title: "Make contact",
    nav: "Contact",
  },
};

/** Reading order for the case index and keyboard navigation. */
export const SECTION_ORDER = [
  "overview",
  "projects",
  "experience",
  "skills",
  "education",
  "portraits",
  "leadership",
  "contact",
];
